import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  all: () => fetchPages<Contact>('contacts', config.ws.contacts.all, 'GET'),
}

export default api
